import { render } from "./FicaHome.vue?vue&type=template&id=25c3239a&scoped=true"
import script from "./FicaHome.vue?vue&type=script&lang=js"
export * from "./FicaHome.vue?vue&type=script&lang=js"

import "./FicaHome.vue?vue&type=style&index=0&id=25c3239a&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c3239a"]])

export default __exports__